exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MultiSelector {\r\n}\r\n\r\n.MultiSelector > label {\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.MultiSelector > .Container {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: row;\r\n\t    flex-direction: row;\r\n\t-ms-flex-align: start;\r\n\t    align-items: flex-start;\r\n}\r\n\r\n.MultiSelector .All {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tmargin-right: 5px;\r\n}\r\n\r\n.MultiSelector .All .Checkbox {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tmargin-right: 5px;\r\n}\r\n\r\n.MultiSelector .All label {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tcolor: #444;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 13px;\r\n}\r\n\r\n.MultiSelector .MultiSelect {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n}\r\n\r\n.MultiSelector.Vertical > .Container {\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-align: stretch;\r\n\t    align-items: stretch;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/vwa/components/MultiSelector/MultiSelector.css
// module id = 695
// module chunks = 0